import React, { useState, useEffect } from "react";
import { Grid, FormLabel, Select, MenuItem } from "@material-ui/core";
import { useStyles } from "src/styles/FormSelectStyles";

export interface Option {
    name: string,
    value: any,
    disabled?: boolean
}

type SelectProps = {
    selectedValue?: string,
    label: string,
    options: Array<Option>,
    showError?: boolean,
    placeholder?: string,
    onSelect: (value:string) => void  
}

/**
 * This is a re-usable Component. Provides an select box with a label. 
 */
const FormSelect : React.FunctionComponent<SelectProps>  = ({ selectedValue, label, options, showError, placeholder, onSelect }) => {
    const styles = useStyles();
    const[selected, setSelected] = useState('');

    useEffect(() => { 
        if (selectedValue) setSelected(selectedValue);
     },[selectedValue]);

    const handleTextChange= (event: React.ChangeEvent<any>) => {
        setSelected(event.target.value);
        onSelect(event.target.value);    
    }

    const listOfOptions = options.map((option) => (
        <MenuItem key={option.value} value={option.value}>
            {option.name}
        </MenuItem>
    ));

    return ( 
        <Grid 
            container
            alignItems="center"  
            spacing={1}>
            <Grid item>
                <FormLabel className={showError ? `${styles.errorLabel}` : `${styles.selectLabel}`}>{label}</FormLabel>
            </Grid>
            <Grid item>
                <Select 
                    className={styles.selectBox}
                    disableUnderline
                    displayEmpty
                    value={selected}
                    onChange={handleTextChange}>
                    <MenuItem value="" disabled>{placeholder}</MenuItem>
                    {listOfOptions}
                </Select>   
            </Grid>
        </Grid>
    );
}

export default FormSelect;
